module.exports = __webpack_public_path__ + "static/media/groceries_image_update.21cceeb9.gif";